var React = require('react');

function Growth (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Statistic_Grow","data-name":"Statistic Grow"},[React.createElement("path",{"d":"M23,22H22V9a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1V22H15V13a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v9H8V16a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1v6H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z","key":0}),React.createElement("path",{"d":"M4,11c6.0086,0,11.3387-4.6041,14-7.3664V5a1,1,0,0,0,2,0V1a1.04,1.04,0,0,0-1-1H15a1,1,0,0,0,0,2h1.7845C14.4209,4.4921,9.4042,9,4,9a1,1,0,0,0,0,2Z","key":1})]));
}

Growth.defaultProps = {"viewBox":"0 0 24 24","width":"512","height":"512"};

module.exports = Growth;

Growth.default = Growth;
